<template>
    <div class="container">
        <div class="column is-half is-offset-one-quarter">
            <transition name="fade">
                <div class="notification is-danger" v-if="this.error !== ''">
                {{error}}
                </div>
            </transition>
            <form class="box" v-on:submit.prevent id="login">
                <h1 class="title">Login</h1>
                <div class="field">
                    <label class="label is-pulled-left">Benutzername</label>
                    <div class="control">
                        <input class="input" type="text" placeholder="Vorname.Nachname" v-model="input.username">
                    </div>
                </div>
                <div class="field">
                    <label class="label is-pulled-left">Passwort</label>
                    <div class="control">
                        <input class="input" type="password" placeholder="Passwort" v-model="input.password">
                    </div>
                </div>
                <button class="button is-pulled-right is-primary" @click="login()">Login</button>
            </form>
        </div>
    </div>
</template>

<script>
    export default  {
        name: 'SignIn',
        data() {
            return {
                error: "",
                input: {
                    username: "",
                    password: "",
                }
            }
        },
        methods: {
            login() {
                this.error = '';
                const {username, password} = this.input;
                this.$store.dispatch('AUTH_REQUEST', {username, password}
                ).then(() => {
                    const name = this.$store.getters.previousRoute.name;
                    this.$router.push({name: name});
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.error = 'Benutzername/Passwort falsch';
                    }
                })
            }
        }
    }
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .75s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
